import { render, staticRenderFns } from "./StaffSettings.vue?vue&type=template&id=5b35d49a&"
import script from "./StaffSettings.vue?vue&type=script&lang=js&"
export * from "./StaffSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports